export default __webpack_public_path__ + "img/0a1d3e5e3c9f87d831e39f5bbfcfa255.svg";